import React, { useState } from "react";
import { Nav } from "react-bootstrap";
import "./NavigationTabs.css";

const NavigationTabs = () => {
  const [activeTab, setActiveTab] = useState("summary");

  const tabs = [
    {
      id: "summary",
      label: "Profile summary",
    },
    {
      id: "resume",
      label: "Resume",
    },
    {
      id: "experience",
      label: "Work experience",
    },
    {
      id: "skills",
      label: "Skills",
    },
    {
      id: "education",
      label: "Education",
    },
    {
      id: "job-preferences",
      label: "Job Preferences",
    },
    {
      id: "personal-details",
      label: "Personal Details",
    },
    {
      id: "courses",
      label: "Courses",
    },
    {
      id: "projects",
      label: "Projects",
    },
    {
      id: "awards",
      label: "Awards",
    },
    {
      id: "social-links",
      label: "Social Links",
    },
    {
      id: "languages",
      label: "Languages",
    },
  ];

  const handleTabClick = (id) => {
    setActiveTab(id);

    const element = document.getElementById(id);

    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <Nav className="profile-tabs">
      {tabs.map((tab) => (
        <Nav.Item key={tab.id}>
          <Nav.Link
            className={
              activeTab === tab.id
                ? "profile-tabs__link active"
                : "profile-tabs__link"
            }
            onClick={() => handleTabClick(tab.id)}
          >
            {tab.label}
          </Nav.Link>
        </Nav.Item>
      ))}
    </Nav>
  );
};

export default NavigationTabs;
